/*
  Lo más visto y lo más buscado (23 oct 2026): pestañas de periodo (día · semana · mes · histórico).
  La portada trae un periodo pintado por Liquid; los demás se piden por Section Rendering sobre /search con
  q=mv:<periodo> (la sección lee el periodo de search.terms) y se guardan en memoria para no volver a pedir.
  Teclado: flechas entre pestañas, Inicio y Fin. El periodo elegido se recuerda en localStorage (moons:mv:periodo)
  y, si no es el pintado, se pide al cargar.
*/
(() => {
  const raiz = document.querySelector('[data-mv]');
  if (!raiz) return;
  const cuerpo = raiz.querySelector('[data-mv-cuerpo]');
  const pestanas = Array.from(raiz.querySelectorAll('[data-mv-periodo]'));
  if (!cuerpo || !pestanas.length) return;

  const CLAVE = 'moons:mv:periodo';
  const cache = new Map();
  let actual = raiz.dataset.periodo;
  cache.set(actual, cuerpo.innerHTML);

  const lee = () => {
    try { return localStorage.getItem(CLAVE); } catch (e) { return null; }
  };
  const guarda = (p) => {
    try { localStorage.setItem(CLAVE, p); } catch (e) { /* sin almacenamiento, nada que guardar */ }
  };

  function marca(p) {
    pestanas.forEach((t) => {
      const activa = t.dataset.mvPeriodo === p;
      t.setAttribute('aria-selected', activa ? 'true' : 'false');
      t.tabIndex = activa ? 0 : -1;
    });
    raiz.dataset.periodo = p;
    cuerpo.setAttribute('aria-labelledby', 'mv-pestana-' + p);
  }

  async function pide(p) {
    const url = raiz.dataset.fuente + '?q=' + encodeURIComponent('mv:' + p) + '&section_id=' + encodeURIComponent(raiz.dataset.seccion);
    const r = await fetch(url, { headers: { Accept: 'text/html' } });
    if (!r.ok) throw new Error(String(r.status));
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const nuevo = doc.querySelector('[data-mv-cuerpo]');
    return nuevo ? nuevo.innerHTML : '';
  }

  async function muestra(p) {
    if (p === actual) return;
    actual = p;
    marca(p);
    guarda(p);
    if (cache.has(p)) {
      cuerpo.innerHTML = cache.get(p);
      return;
    }
    raiz.setAttribute('aria-busy', 'true');
    try {
      const html = await pide(p);
      if (html) cache.set(p, html);
      if (actual === p && html) cuerpo.innerHTML = html;
    } catch (e) {
      /* si falla, se queda lo que había */
    }
    if (actual === p) raiz.removeAttribute('aria-busy');
  }

  pestanas.forEach((t) => t.addEventListener('click', () => muestra(t.dataset.mvPeriodo)));

  raiz.querySelector('[role="tablist"]').addEventListener('keydown', (e) => {
    const i = pestanas.findIndex((t) => t === document.activeElement);
    if (i < 0) return;
    let j = -1;
    if (e.key === 'ArrowRight') j = (i + 1) % pestanas.length;
    else if (e.key === 'ArrowLeft') j = (i - 1 + pestanas.length) % pestanas.length;
    else if (e.key === 'Home') j = 0;
    else if (e.key === 'End') j = pestanas.length - 1;
    if (j < 0) return;
    e.preventDefault();
    pestanas[j].focus();
    muestra(pestanas[j].dataset.mvPeriodo);
  });

  const recordado = lee();
  if (recordado && recordado !== actual && pestanas.some((t) => t.dataset.mvPeriodo === recordado)) {
    muestra(recordado);
  }
})();
